import React from 'react';
import { willShowModal } from '../Common/Modal/Modal';
import Countries from './Countries';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

export const NavButton = (props) => {
  const {
    ...otherProps
  } = props;
  return (
    <button aria-label={props.id} className='d-flex text-gray-darken-1 btn btn-link'
            {...otherProps}
    >
      <small>{props.children}</small>
    </button>
  );
};

export const NavImgButton = (props) => {
  return (
    <button className='text-gray-darken-1 btn btn-link px-2' aria-label='PB Pass'>
      <img {...props}/>
    </button>
  );
}

export const NavCart = props => (
  <NavButton
    className='d-flex text-gray-darken-1 btn btn-link nav__shopping-cart'
    id='cartLink'
    {...props}
  >
    <i className="fa fa-shopping-cart"></i>
    {props.children}
  </NavButton>
);

const NavFlagContent = (props) => {
  const {
    flag = '',
    countryName = '',
    currency = '$USD',
    isMobile = false,
    ...otherProps
  } = props;
  return (
    <NavButton
      className='d-flex text-gray-darken-1 btn btn-link mx-1 mx-lg-0'
      {...otherProps}
    >
      <div className='d-flex align-items-center'>
        {config.storeCode !== 'PBWW' &&
          <img className="nav__flag--header-size" src={flag} width="21" height="16" alt={countryName}/>
        }
        <div className='m-1'>{currency}</div>
        {isMobile &&
        <div className="text-primary"><span className='text-gray-lighten-2'>|</span> <span className="ProximaNova-Bold"><HTMLTrans id="navbar.viewcomponents_change_country">change</HTMLTrans></span>
        </div>}
      </div>
    </NavButton>
  );
};

const CountryModal = willShowModal({ size: 'lg' })(NavFlagContent);


export const NavFlag = props => (
  <CountryModal {...props}>
    {() => (<Countries isMobile={props.isMobile}/>)}
  </CountryModal>
);



// WEBPACK FOOTER //
// ./src/Nav/ViewComponents.js